import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef }                 from "@angular/material/dialog";

@Component({
	selector: 'app-dialog',
	templateUrl: './dialog.component.html',
	styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit, OnDestroy {

	content:string = null;

	constructor(public dialogRef: MatDialogRef<DialogComponent>) {
	}

	ngOnInit() {
		if(this.content === null) {
			this.close();
			return;
		}
	}

	ngOnDestroy(){

	}

	close(){
		this.dialogRef.close();
	}


}
